<template>
	<div class="customer-sex">
		<div class="title">成长值：</div>
		<div class="tip">客户当前成长值。你可以结合会员级别条件标签，给已达到成长值门槛却还没有激活会员身份的客户推送内容或打标签</div>

		<div class="flex">
			<div class="flex">
				<num-mod ref="numMod" :disabled="disabled" txt="个" :precision="0"></num-mod>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		MemberUserlevels
	} from '@/api/TurnTomySelf';
	
	import numMod from '../components/num.vue';

	export default {
		components: {
			numMod
		},
		props: {
			type: {
				type: Number,
				default: 0
			},
			itemData: {
				type: Object,
				default: ()=>{
					return {}
				}
			},
			disabled: {
				type:Boolean,
				default:false
			}
		},
		data() {
			return {
			};
		},
		mounted() {
			if(this.itemData.Id){
				var obj = JSON.parse(JSON.stringify(this.itemData));
				var mod = this.$refs['numMod'];
				for (let item in mod.ruleForm){
					mod.ruleForm[item] = obj[item];
				}
			}
		},
		methods: {
			validForm() {
				return new Promise((resolve, reject) => {
					
					this.$refs['numMod'].validForm().then(res=>{
						var obj = {
							TagRuleConfigId: 0,
							Type: this.type,
							ConditionType: res.value,
							Num: res.value === 6 ? res.min : res.total,
							MaxNum: res.max
						}
						resolve(obj);
					}).catch(err=>{
						reject();
					})
				})

			}
		}
	}
</script>

<style lang="less" scoped>
	.customer-sex {
		padding: 15px 20px 1px;

		.title {
			font-size: 14px;
			margin-bottom: 7px;
		}

		.tip {
			font-size: 13px;
			color: #999;
			margin-bottom: 15px;
		}
		
		.flex{
			display: flex;
			line-height: 36px;
			white-space: nowrap;
			flex-wrap: wrap;
		}
	}
</style>
